Wee.fn.make('downloadButtons', {
	init: function() {
		var $buttons = $('ref:downloadButtons');

		Wee.screen.map([
			{
				max: 3,
				callback: function() {
					$('ref:slideBlock').after($buttons);
				}
			},
			{
				min: 4,
				callback: function() {
					$('ref:slideContent').append($buttons);
				}
			}
		]);
	}
});